import {
  getCabinCategories,
  getCruiseOfferMemberPriceVariation,
  getCruiseOfferPriceVariation,
  type CruiseOfferPriceVariation,
} from './cruiseUtils'

export interface CruiseDepartureCabinPrice {
  category: string
  discountPercentage?: number
  hasPrice: boolean
  memberPrice?: number
  memberPriceType?: App.Cruises.CruiseMemberPriceType
  primaryPrice: CruiseOfferPriceVariation['primaryPrice']
  secondaryPrice?: CruiseOfferPriceVariation['secondaryPrice']
}

export function getCruiseDeparturePrices(
  lowestDeparturePricesByCategory: App.LowestDeparturePricesByCategory,
  departureId: string,
): Array<number> {
  return Object.values(lowestDeparturePricesByCategory[departureId] ?? {})
    .map((price) => price.total)
    .filter((price) => Number.isFinite(price) && price > 0)
}

export function isCruiseDepartureSoldOut(
  lowestDeparturePricesByCategory: App.LowestDeparturePricesByCategory,
  departureId: string,
): boolean {
  return getCruiseDeparturePrices(lowestDeparturePricesByCategory, departureId).length === 0
}

export function getCruiseDepartureCabinPrices(
  offer: App.CruiseOffer,
  departure: App.CruiseDepartureDetails,
  departureMemberPricingByCategory: Record<string, App.Cruises.CruiseOfferMemberPriceByCategory>,
): Array<CruiseDepartureCabinPrice> {
  const pricesByCabinCategory = offer.lowestDeparturePricesByCategory[departure.id]

  if (isCruiseDepartureSoldOut(offer.lowestDeparturePricesByCategory, departure.id)) return []

  return getCabinCategories(offer.cruiseType).map((item) => {
    const category = item.category.toLowerCase()
    const cabinPrice = pricesByCabinCategory[category]
    const memberPrice = departureMemberPricingByCategory[category]?.memberPrice
    const { primaryPrice, secondaryPrice } = getCruiseOfferPriceVariation(offer, cabinPrice)
    const memberPriceVariation = getCruiseOfferMemberPriceVariation(offer, memberPrice)

    return {
      category,
      primaryPrice,
      secondaryPrice,
      hasPrice: !!(primaryPrice.total || secondaryPrice?.total),
      memberPrice: memberPriceVariation?.primaryPrice.total,
      memberPriceType: departureMemberPricingByCategory[category]?.memberPriceType,
      discountPercentage: cabinPrice?.brochureDiscountPercentage,
    }
  })
}
